export function getUrlWithNewQueryParameter(key: string, value: string): string {
  let url = window.location.href;
  let hash;
  const regExp = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi');

  if (regExp.test(url)) {
    return url.replace(regExp, '$1' + key + '=' + value + '$2$3');
  } else {
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    hash = url.split('#');
    url = hash[0] + separator + key + '=' + value;

    if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
      url += '#' + hash[1];
    }

    return url;
  }
}

export function getParameterValueByQueryName(name: string, url = window.location.href): string | null {
  const query = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + query + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function addQueryParameter(key: string, value: string): void {
  const preparedUrl = getUrlWithNewQueryParameter(key, value);

  window.history.replaceState(null, document.title, preparedUrl);
}

export function removeURLParameter(parameter: string): void {
  const url = window.location.href;

  const preparedUrl = url
    .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
    .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');

  window.history.replaceState(null, document.title, preparedUrl);
}

export function setQueryParameter(key: string, value: string | number | boolean | void): void {
  if (!value) {
    removeURLParameter(key);

    return;
  }

  const preparedValue = typeof value !== 'string' ? String(value) : value;

  addQueryParameter(key, preparedValue);
}
